import CroustilleElement from "../lib/CroustilleElement";
import buildThresholdList from "../lib/buildThresoldList";

const CROUSTILLE = window.CROUSTILLE || {};

// const HIDDEN_CLASS = "s-hidden";
// const FADE_IN_CLASS = "s-fade-in";
export const PLAY_EVENT = "video:play";
export const PAUSE_EVENT = "video:pause";

const pauseEvent = new Event(PAUSE_EVENT);
const playEvent = new Event(PLAY_EVENT);

// const canPlay = (element) => {
//   return getComputedStyle(element, null).display !== "none";
// };

class Video extends CroustilleElement {
  constructor() {
    super("video");
  }

  observe(node) {
    if (typeof CROUSTILLE.videoObserver === "undefined") {
      const threshold = buildThresholdList();

      const options = {
        root: null,
        rootMargin: "0px",
        threshold,
      };

      CROUSTILLE.videoObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (entry.intersectionRatio >= 0.1) {
                if (entry.target && entry.target.video.nodeName === "VIDEO") {
                  entry.target.video.paused === true && entry.target.play();
                } else {
                  entry.target.dispatchEvent(playEvent);
                }
              } else {
                if (entry.target && entry.target.video.nodeName === "VIDEO") {
                  entry.target.video.paused === false && entry.target.pause();
                } else {
                  entry.target.dispatchEvent(pauseEvent);
                }
              }
            }
          });
        },
        options
      );
    }

    CROUSTILLE.videoObserver.observe(node);
  }

  play() {
    if (this.video && this.video.nodeName === "VIDEO") {
      this.video.paused === true && this.video.play();
    } else {
      this.video.dispatchEvent(this.playEvent);
    }
  }

  pause() {
    if (this.video && this.video.nodeName === "VIDEO") {
      this.video.paused === false && this.video.pause();
    } else {
      this.video.dispatchEvent(this.pauseEvent);
    }
  }

  // hide() {
  //   this.pause();
  //   this.video.classList.add(HIDDEN_CLASS);
  // }

  // show() {
  //   this.video.classList.remove(HIDDEN_CLASS);
  // }

  get video() {
    return this.querySelector("video");
  }

  init() {
    this.observe(this);
  }

  resized() {}

  destroy() {
    CROUSTILLE.videoObserver.unobserve(this);
  }
}

export default Video;
